// src/utils/cardActions.js
import React from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import useClickOutside from '../UseClickOutside';
import { iconsPath } from '../../utils/imagePath';
import useFocusTrap from '../../Hooks/useFocusTrap';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getAuthConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    'Content-Type': 'application/json',
  },
});

// ✅ Rename card
export const renameCard = async (projectId, newName) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}experience/update/experience-name/${projectId}`,
      { project_name: newName },
      getAuthConfig()
    );
    return response.data;
  } catch (error) {
    console.error('Rename Error:', error);
    throw error;
  }
};

// ✅ Delete card
export const deleteCard = async (projectId) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}experience/${projectId}`,
      getAuthConfig()
    );
    toast.success('Project deleted successfully');
    return response.data || { success: true };
  } catch (error) {
    console.error('Delete Error:', error);
    throw error;
  }
};

// ✅ Duplicate card (with hardcoded full URL)
export const duplicateCard = async (projectId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}experience/duplicate/${projectId}`,
      {},
      getAuthConfig()
    );
    toast.success('Project duplicated successfully');
    return response.data;
  } catch (error) {
    console.error('Duplicate Error:', error);
    toast.error('Duplicate failed');
    throw error;
  }
};

// src/components/ConfirmDialog.js

export default function ConfirmDialog({ open, onClose, onConfirm, message }) {
  if (!open) return null;
  const deleteRef = React.useRef(null);
  const cancelButtonRef = React.useRef(null);
  const deleteButtonRef = React.useRef(null);

  useClickOutside(deleteRef, onClose);
  useFocusTrap(open, onClose, cancelButtonRef, deleteButtonRef, deleteButtonRef);

  return (
    <div className="fixed inset-0 bg-black/60  z-50 flex items-center justify-center p-4">
      <div
        ref={deleteRef}
        className="bg-[#000000] rounded-2xl shadow-2xl w-full max-w-md mx-auto transform transition-all scale-100 animate-in zoom-in-95 duration-200"
      >
        {/* Content */}
        <div className="p-6 text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-[#EE2B2A] bg-opacity-20 rounded-full flex items-center justify-center">
            <img src={iconsPath?.historyDeleteWarning} alt="" />
          </div>

          <h3 className="text-lg font-semibold text-white mb-2">
            Confirm Delete
          </h3>

          <p className="text-white text-opacity-75 text-sm leading-relaxed mb-6">
            {message}
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              ref={cancelButtonRef}
              onClick={onClose}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-[#31333A] rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 focus:ring-offset-[#000000]"
            >
              Cancel
            </button>
            <button
              ref={deleteButtonRef}
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-[#EE2B2A] hover:bg-red-700 rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-[#000000]"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
